module.exports = __webpack_public_path__ + "media/images/signatures/edelmira_lopez-dd7c7122b6e70adaaaccf124f220dbc161a856808d321822e3cfe21c37e118b8.png";